






























import NoResults from "@/components/ui/NoResults.vue";

import { Component } from "vue-property-decorator";
import BaseInternalSheetValorization from "@/components/pages/valorizations/internal/observatory/BaseInternalSheetValorization.vue";

@Component({
  components: { NoResults }
})
export default class PatrimonialSheetTwoSheet extends BaseInternalSheetValorization {
  protected model = [];
  protected url = "/valorization/observatory/flora/patrimonial-sheet-two";

  get headers() {
    return this.model.map(item => ({text: item.label, value: item.name}));
  }

  drawData() {
    this.data = this.data.length > 0 ? this.data : [];
  }
}
